import type { Reaction, Reactor, TargetKind } from "../../net/api.ts";

export type { Reaction, Reactor } from "../../net/api.ts";

export type Target = { kind: TargetKind; id: string };

const YOU: Reactor = { account: "", handle: "", displayName: null, avatar: null, you: true };

export const SIX = ["👍", "❤️", "😂", "🎉", "👀", "🙏"] as const;

const REST: Array<{ emoji: string; words: string }> = [
  { emoji: "👍", words: "yes thumbs up agree ok" },
  { emoji: "👎", words: "no thumbs down disagree" },
  { emoji: "❤️", words: "heart love" },
  { emoji: "😂", words: "laugh funny joy" },
  { emoji: "🎉", words: "party tada celebrate ship shipped" },
  { emoji: "👀", words: "eyes looking reading watching" },
  { emoji: "🙏", words: "thanks please pray grateful" },
  { emoji: "🔥", words: "fire hot good great" },
  { emoji: "🚀", words: "rocket ship launch fast" },
  { emoji: "✅", words: "check done tick complete" },
  { emoji: "❌", words: "cross no wrong failed" },
  { emoji: "🤔", words: "thinking hmm unsure question" },
  { emoji: "😅", words: "sweat nervous laugh phew" },
  { emoji: "😭", words: "crying sad sob" },
  { emoji: "😍", words: "love heart eyes adore" },
  { emoji: "🥳", words: "party face celebrate birthday" },
  { emoji: "😎", words: "cool sunglasses" },
  { emoji: "🙌", words: "hands raised praise yay" },
  { emoji: "👏", words: "clap applause well done" },
  { emoji: "💯", words: "hundred perfect exactly" },
  { emoji: "🧠", words: "brain smart clever idea" },
  { emoji: "💡", words: "idea bulb light suggestion" },
  { emoji: "🐛", words: "bug defect insect" },
  { emoji: "⚠️", words: "warning careful danger" },
  { emoji: "🛑", words: "stop halt blocked" },
  { emoji: "⏳", words: "waiting time hourglass slow" },
  { emoji: "☕", words: "coffee break" },
  { emoji: "🍕", words: "pizza food lunch" },
  { emoji: "🎯", words: "target bullseye exact point" },
  { emoji: "📌", words: "pin pinned keep" },
  { emoji: "📎", words: "clip attach file" },
  { emoji: "🔒", words: "lock secure private" },
  { emoji: "🤝", words: "handshake deal agreed" },
  { emoji: "🫡", words: "salute on it acknowledged" },
  { emoji: "🤯", words: "mind blown exploding" },
  { emoji: "😴", words: "sleep tired snooze" },
  { emoji: "🙃", words: "upside down irony" },
  { emoji: "💪", words: "strong muscle effort" },
  { emoji: "🌱", words: "seedling growth new" },
  { emoji: "🧹", words: "broom cleanup tidy" },
];

export function matching(query: string, most = 12): string[] {
  const asked = query.trim().toLowerCase();
  if (asked.length === 0) return [];
  const found = REST.filter((one) => one.emoji === asked || one.words.includes(asked));
  return found.slice(0, most).map((one) => one.emoji);
}

export function afterToggling(
  reactions: readonly Reaction[],
  emoji: string,
  now: string = new Date().toISOString(),
): Reaction[] {
  const already = reactions.find((one) => one.emoji === emoji);
  if (!already) return [...reactions, { emoji, count: 1, mine: true, at: now, who: [YOU] }];
  if (!already.mine) {
    return reactions.map((one) =>
      one.emoji === emoji ? { ...one, count: one.count + 1, mine: true, who: [...one.who, YOU] } : one,
    );
  }

  return reactions
    .map((one) =>
      one.emoji === emoji
        ? { ...one, count: one.count - 1, mine: false, who: one.who.filter((who) => !who.you) }
        : one,
    )
    .filter((one) => one.count > 0);
}

export const pressWouldRemove = (reactions: readonly Reaction[], emoji: string): boolean =>
  reactions.some((one) => one.emoji === emoji && one.mine);
